/**
 * Storage Key Constants
 */
export const STORAGE_KEYS = {
  token: 'auth_token',
  credentials: 'saved_credentials',
  user: 'user_data',
  fcmToken: 'fcm_token',
} as const;

export type StorageKey = typeof STORAGE_KEYS[keyof typeof STORAGE_KEYS];

